export default "__VITE_ASSET__BmrMjj$H__"